import { SelectionModel } from '@angular/cdk/collections';
import { TableApiDataSource } from './table.api-data-source';

export interface TypeWithId {
    id: string | number;
}

export class TableSelectionModel<ItemType extends TypeWithId> extends SelectionModel<ItemType> {
    public constructor(private dataSource: TableApiDataSource<ItemType>) {
        super(true, []);
    }

    public getSelectedCount(): number {
        return this.selected.length;
    }

    public toggleItem(item: ItemType, newState: boolean): void {
        newState ? this.selectItem(item) : this.deselectItem(item);
    }

    public selectItem(item: ItemType): void {
        const isAlreadySelected = this.selected.find((selectedItem) => selectedItem.id == item.id);

        if (!isAlreadySelected) {
            this.select(item);
        }
    }

    public deselectItem(item: ItemType): void {
        const isAlreadySelected = this.selected.find((selectedItem) => selectedItem.id == item.id);

        if (isAlreadySelected) {
            this.deselect(item);
        }
    }

    public isSelectedItem(item: ItemType): boolean {
        const isAlreadySelected = this.selected.find((selectedItem) => selectedItem.id == item.id);

        return !!isAlreadySelected;
    }

    public masterToggle(): void {
        if (this.isAllSelected()) {
            this.clear();
        } else {
            this.dataSource.Data.forEach((item) => this.selectItem(item));
        }
    }

    public isAllSelected(): boolean {
        const selectedItemsCount = this.selected.length;

        if (!selectedItemsCount) {
            return false;
        }

        const itemsCount = this.dataSource.Paginator.length;
        const pageIndex = this.dataSource.Paginator.pageIndex;
        const pageSize = this.dataSource.Paginator.pageSize;
        const pagesCount = this.dataSource.Paginator.getNumberOfPages();

        if (pageIndex + 1 === pagesCount) {
            // The last page is being displayed, so check with this formula
            return selectedItemsCount === itemsCount - pageIndex * pageSize;
        }

        return selectedItemsCount === pageSize;
    }

    public getCheckboxLabel(item?: ItemType): string {
        if (!item) {
            // Get label for the master checkbox
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }

        const index = this.dataSource.Data.indexOf(item);

        return `${this.isSelected(item) ? 'deselect' : 'select'} item ${index}`;
    }
}
